const SEARCH_SEPARATOR_PATTERN = /[-_/\\|]+/g;
const WHITESPACE_PATTERN = /\s+/g;

export function normalizeSearchText(value: string | null | undefined): string {
  return String(value || '')
    .replace(SEARCH_SEPARATOR_PATTERN, ' ')
    .replace(WHITESPACE_PATTERN, ' ')
    .trim()
    .toLowerCase();
}

export function splitNormalizedSearchTerms(value: string | null | undefined): string[] {
  return String(value || '')
    .split(',')
    .map((term) => normalizeSearchText(term))
    .filter(Boolean);
}

export function matchesNormalizedSearch(
  haystack: string | null | undefined,
  query: string | null | undefined,
): boolean {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return true;
  return normalizeSearchText(haystack).includes(normalizedQuery);
}

export function matchesAnyNormalizedSearchTerm(
  haystack: string | null | undefined,
  terms: string[],
): boolean {
  if (terms.length === 0) return false;
  const normalizedHaystack = normalizeSearchText(haystack);
  return terms.some((term) => normalizedHaystack.includes(term));
}
